<template>
  <PageViewContainer>
    <CardContainer>
      <template v-slot:title>
        {{ text.pages.cart.transactionThanksTitle }}
      </template>
      <template v-slot:content>
        {{ text.pages.cart.transactionThanksText }}
      </template>
    </CardContainer>
  </PageViewContainer>
</template>

<script>
import { translations } from '@/lang/translations';
import CardContainer from '@/components/Partials/CardContainer.vue';
import PageViewContainer from '../Partials/PageViewContainer.vue';

export default {
  name: 'TransactionBackSite',
  components: { CardContainer, PageViewContainer },
  data() {
    return {
      text: translations.pl,
    };
  },
};
</script>

<style scoped>

</style>
